import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, coalesce } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaEntrega } from "../model";

export interface Props {
    value: GuiaEntrega;
    onSeleccionar: (x: boolean | null) => void;
    onMotivoChange: (x: string) => void;
}



const OptionButton = (props: { selected: boolean, onClick: () => void, children: string }) =>
    <kea.Button onClick={props.onClick} style={props.selected ? "info" : "default"}>
        {props.children}
    </kea.Button>;
const Entregada = (props: { selected: boolean, onClick: () => void }) => <OptionButton {...props} children="Entregada" />;
const Rechazada = (props: { selected: boolean, onClick: () => void }) => <OptionButton {...props} children="Rechazada" />;
const Excluida = (props: { selected: boolean, onClick: () => void }) => <OptionButton {...props} children="Excluída" />;

export class GuiaItem extends React.PureComponent<Props> {
    render() {
        const x = this.props.value;
        return (
            <kea.Panel
                title={
                    <span style={{ fontFamily: "monospace" }} >
                        {x.guia.Folio}
                    </span>
                }
                style={x.seleccionada == false ? "danger" : x.seleccionada == true ? "success" : "default"}  >
                <div className="btn-group">
                    <Excluida selected={x.seleccionada == null} onClick={() => this.props.onSeleccionar(null)} />
                    <Rechazada selected={x.seleccionada == false} onClick={() => this.props.onSeleccionar(false)} />
                    <Entregada selected={x.seleccionada == true} onClick={() => this.props.onSeleccionar(true)} />
                </div>

                {
                    <kea.Text value={x.motivoRechazo} placeholder="Motivo de rechazo" onChange={this.props.onMotivoChange} readonly={x.seleccionada != false} />
                }
                <br />

                <label>Importe a pagar:</label>{" "}{
                    kea.formatCurrency(
                    (x.guia.FletePorCobrar ) ?
                    (x.guia.Importes ? x.guia.Importes.Total : 0) : 0)}
                <br />

                <label>Paquetes:</label>
                {
                    x.guia.DescripcionPaquetesTexto ? 
                    <ul>
                        {x.guia.DescripcionPaquetesTexto.split(",").map((x, i) => <li key={i} >{x}</li>)}
                    </ul> : 
                    <i>Ninguno</i>
                }
                <br />
                <label>Sobres:</label>{x.guia.CantidadSobres}
                <br />
                <label>Tipo acuse:</label>{" "}{coalesce(nullsafe(x.guia.ServiciosAdicionales.TipoAcuse, x => models.TipoAcuse[x]), "(ninguno)")}{" "}{x.guia.ServiciosAdicionales.TipoAcuse == models.TipoAcuse.Externo ? ("(" + x.guia.ServiciosAdicionales.NombreRequerimientoAcuse + ")") : "" }
            </kea.Panel>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/list/item.tsx